import React from 'react'
import { formatMessage } from '../constants/strings/intl/intlHooks'
import { messages } from '../constants/strings/messages'
import { icons } from '../constants/searchAssets'
import { atlTheme } from '../atlTheme'
import { useGlobal } from '../global/useGlobal'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import styled from 'styled-components'

interface ConstructionModuleSelectorProps {
  onChange?: (item) => void
}

const FormControlWeb = styled(FormControl)`
  width: 100%;
`

const WrapperDropdown = styled.div`
  display: flex;
`

const Icon = styled.img`
  width: ${atlTheme.SizeAvatarSmall}px;
  height: ${atlTheme.SizeAvatarSmall}px;
  align-self: center;
  margin: 0 ${atlTheme.SpacingMarginal}px;
`

export const ConstructionModuleSelector: React.FC<ConstructionModuleSelectorProps> = ({ onChange }) => {
  const [dropdownUserSaleContractsData] = useGlobal('dropdownUserSaleContractsData')
  const [value, setValue] = useGlobal('selectedUserSaleContract')

  const onChangeDropdown = async item => {
    await setValue(item)
    onChange && onChange(item)
  }

  return (
    <>
      {dropdownUserSaleContractsData && (
        <WrapperDropdown>
          <Icon src={icons.towerIcon} />
          <FormControlWeb>
            <InputLabel>{formatMessage(messages.financeBillsScreen_dropdown_title)}</InputLabel>
            <Select value={value.text} onChange={onChangeDropdown}>
              {dropdownUserSaleContractsData.map(item => (
                <MenuItem key={item.id} value={item.text}>
                  {item.text}
                </MenuItem>
              ))}
            </Select>
          </FormControlWeb>
        </WrapperDropdown>
      )}
    </>
  )
}
